export default {
  name: "idea",
  props: {
    idea: Array
  },
  computed: {
    query: function query() {
      return this.idea[1];
    },
    text: function text() {
      return this.idea[1];
    },
    imageSrc: function imageSrc() {
      return this.idea[5];
    },
    totalSuppliers: function totalSuppliers() {
      return this.idea[2];
    }
  }
};